module.exports = __webpack_public_path__ + "img/ipad-default.bbb2091d.jpg";